import { useQuery } from "@tanstack/react-query";
import { ApiResponse } from "../../apis/data";
import { queryKey } from "../../enumerations/queryKey";
import { SkiResortResponse } from "./data";
import { apiGetSkiResort } from "./service";

export const useGetSkiResort = (options: any) => {
  return useQuery<SkiResortResponse[]>({
    queryKey: [queryKey.RESORT_LIST],
    queryFn: () =>
      apiGetSkiResort().then(
        (res: ApiResponse<SkiResortResponse[]>) => res.data.data
      ),
    ...options,
    staleTime: 1000 * 60 * 5,
  });
};
